import PropTypes from "prop-types";
import {useState} from "react";
import appleImage from "assets/images/apple.svg";
import spotifyImage from "assets/images/spotify.svg";
import useAppContext from "lib/hooks/use-app-context";

function AudioLinks({episode}) {
  const {channel} = useAppContext();
  const [showAudio, setShowAudio] = useState(false);
  const audioLink = `/episodes/${episode.uid}/audio.${episode.audio_extension}`;
  const itunesLink = episode.itunes_link || channel.itunes_link;
  const spotifyLink = episode.spotify_link || channel.spotify_link;

  return (
    <>
      {(itunesLink || spotifyLink) && (
        <div className="my-1 store-links">
          {itunesLink && (
            <a className="apple" href={itunesLink} rel="noreferrer" target="_blank">
              <img alt="Listen on Apple Podcasts" width="200" src={appleImage} />
            </a>
          )}
          {spotifyLink && (
            <a className="spotify" href={spotifyLink} rel="noreferrer" target="_blank">
              <img alt="Listen on Spotify Podcasts" width="200" src={spotifyImage} />
            </a>
          )}
        </div>
      )}
      {showAudio ? (
        <audio controls={true} src={audioLink} type={episode.audio_type}>
          <a href={audioLink}>
            <i className="fas fa-headphones" /> Listen
          </a>
        </audio>
      ) : (
        <button className="btn btn-themed my-2" onClick={() => setShowAudio(true)} type="button">
          <i className="fas fa-play" /> Play
        </button>
      )}
    </>
  );
}

AudioLinks.propTypes = {
  episode: PropTypes.shape({
    audio_extension: PropTypes.string.isRequired,
    audio_type: PropTypes.string.isRequired,
    itunes_link: PropTypes.string,
    spotify_link: PropTypes.string,
    uid: PropTypes.string.isRequired
  }).isRequired
};

export default AudioLinks;
